import React from 'react'

import { ModsenWrappingUp2023WithCTO } from '@components/articles/ModsenWrappingUp2023WithCTO'
import { CustomHead } from '@ui/sections/CustomHead'

function ModsenWrappingUp2023WithCtoPage() {
  return (
    <>
      <CustomHead
        title="Closing 2023 with Modsen’s CTO: Pioneering Tech, Resilient Teams, and Year-End Reflections"
        imagePath="/images/articles/modsen-wrapping-up-2023-with-cto/opengraph.webp"
        description="Delve into this exclusive year-end conversation to gain insights into Modsen’s strides in 2023, the tech landscape, and the shared journey of success."
        pageType="article"
      />
      <ModsenWrappingUp2023WithCTO />
    </>
  )
}

export default ModsenWrappingUp2023WithCtoPage
